module.exports = __webpack_public_path__ + "onboarding-push.f34f87c3ede65edf49b3282f0e2458de.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-push.svg
// module id = 2332180999227864
// module chunks = 1